import { render, staticRenderFns } from "./FormSelectEvent.vue?vue&type=template&id=2dbee5c2"
import script from "./FormSelectEvent.vue?vue&type=script&lang=js"
export * from "./FormSelectEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports